/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * User activity level model
 */
export type ActivityLevel = {
  activityLevel: ActivityLevel.activityLevel;
};
export namespace ActivityLevel {
  export enum activityLevel {
    SEDENTARY_NO_EXERCISE = "Sedentary - No exercise",
    LIGHTLY_ACTIVE_EXERCISE_1_3_DAYS_WEEK = "Lightly active - Exercise 1-3 days/week",
    MODERATELY_ACTIVE_EXERCISE_3_5_DAYS_WEEK = "Moderately active - Exercise 3-5 days/week",
    VERY_ACTIVE_EXERCISE_6_7_DAYS_A_WEEK = "Very active - Exercise 6-7 days a week",
    EXTRA_ACTIVE_VERY_HARD_EXERCISE_AND_PHYSICAL_JOB = "Extra active - Very hard exercise and physical job",
  }
}
